import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-4" }
const _hoisted_3 = { class: "col-span-12 lg:col-span-6" }
const _hoisted_4 = { class: "col-span-12 md:col-span-6 lg:col-span-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", null, "LUSD3CRV-f—ePyvCurveLUSD", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Element principal pool Yearn crvLUSD v2 vault. ", -1)
const _hoisted_7 = { class: "col-span-12 md:col-span-6 lg:col-span-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h6", null, "USDC—ePyvUSDC", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " Element principal pool Yearn USDC v2 vault. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('featuredProtocol')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BalCard, {
          title: "Element Finance",
          imgSrc: "/images/banners/element.jpg",
          class: "transition-shadow hover:shadow-xl",
          hFull: "",
          growContent: ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_BalLink, {
              href: _ctx.EXTERNAL_LINKS.Element.Earn,
              external: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('viewAndManangeOnElement')), 1),
                _createVNode(_component_BalIcon, {
                  name: "arrow-up-right",
                  size: "sm",
                  class: "ml-1"
                })
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('aboutElementFinance')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_BalCard, {
          title: "LUSD",
          imgSrc: "/images/banners/element-lusd.svg",
          class: "transition-shadow hover:shadow-xl",
          hFull: "",
          growContent: ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_BalLink, {
              href: _ctx.EXTERNAL_LINKS.Element.Pools.LUSD,
              external: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('viewOnElement')), 1),
                _createVNode(_component_BalIcon, {
                  name: "arrow-up-right",
                  size: "sm",
                  class: "ml-1"
                })
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_BalCard, {
          title: "USDC",
          imgSrc: "/images/banners/element-usdc.svg",
          class: "transition-shadow hover:shadow-xl",
          hFull: "",
          growContent: ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_BalLink, {
              href: _ctx.EXTERNAL_LINKS.Element.Pools.USDC,
              external: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('viewOnElement')), 1),
                _createVNode(_component_BalIcon, {
                  name: "arrow-up-right",
                  size: "sm",
                  class: "ml-1"
                })
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          default: _withCtx(() => [
            _hoisted_8,
            _hoisted_9
          ]),
          _: 1
        })
      ])
    ])
  ]))
}